import api from './api';

const airportService = {
  // Get airport list with optional search parameter and pagination
  getAirportList: async (searchTerm = '', page = 1, limit = 50) => {
    try {
      const params = new URLSearchParams();
      if (searchTerm) {
        params.append('search', searchTerm);
      }
      params.append('page', page);
      params.append('limit', limit);

      const queryString = params.toString();
      const url = `/getairportlist?${queryString}`;

      const response = await api.get(url);

      // Handle both old format (array) and new format (object with data and pagination)
      if (Array.isArray(response)) {
        // Old format - return as is with no pagination info
        return {
          data: response,
          pagination: {
            hasMore: false,
            page: page,
            total: response.length
          }
        };
      } else if (response.data) {
        // New format with pagination
        return {
          data: response.data,
          pagination: response.pagination || {
            hasMore: false,
            page: page,
            total: response.data.length
          }
        };
      } else {
        // Fallback
        return {
          data: response || [],
          pagination: {
            hasMore: false,
            page: page,
            total: 0
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },

  // Get multiple airports by their IDs
  getAirportsByIds: async (ids) => {
    try {
      if (!ids || ids.length === 0) return { data: [] };
      const idString = ids.join(',');
      const response = await api.get(`/utility/airports/ids?ids=${idString}`);
      return response;
    } catch (error) {
      console.error('getAirportsByIds error:', error);
      throw error;
    }
  }
};

export default airportService;